export default "__VITE_ASSET__3a8gN2hk__"